export const WITHDRAWAL_TYPE_OPTIONS = [
  {
    value: 'instant',
    labelKey: 'settings_autoWithdrawal_instantTypeTitle',
    descriptionKey: 'settings_autoWithdrawal_instantTypeDescription',
    id: 'Instant',
  },
  {
    value: 'manual',
    labelKey: 'settings_autoWithdrawal_manualTypeTitle',
    descriptionKey: 'settings_autoWithdrawal_manualTypeDescription',
    id: 'Manual',
  },
];
